import EditAbleHostProfile from "./EditAbleHostProfile";
import { useNavigate, useParams } from "react-router-dom";
import EditAbleJudgeProfile from "./EditAbleJudgeProfile";
import EditAbleMemberProfile from "./EditAbleMemberProfile";
import PageInfo from "shared/Components/pageInfo";

export default function EditAbleProfiles() {
  const navigate = useNavigate();

  const {  role } = useParams();
  return (
    <div className="App lg:rounded-md min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10">
      <PageInfo title={role} onClick={() => navigate(-1)}/>
      {role === "Judge" ? (
        <EditAbleJudgeProfile />
      ) : role === "Host" ? (
        <EditAbleHostProfile />
      ) : (
        <EditAbleMemberProfile />
      )}
    </div>
  );
}
